module.exports = __webpack_public_path__ + "static/img/tyzx_banner.d57999d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/tyzx_banner.png
// module id = phQw
// module chunks = 1